export  default {   
    //admin user
    user: {},    
    //category
    categoryDescription: '',
    categoryImages: [],
    //html editor
    htmlEditEntity: {textAction: '', imageAction: '', imageSaveCallBack: '', text: '', image: ''},
    //article
    articleDescription: '',
    //comment
    commentDescription: '',
    //language entity
    languageEntity: {name: 'language', label: 'Language', selected: 'he_IL', onSelectCB: ''},
    //site data
    siteData: {},
    //source json
    sourceJson: '',
    //selected language
    selectedLanguage: '',
    //data loaded
    dataLoaded: false,
};